import React from 'react'
import { CompError } from '../../../Complex'
import { Card, Grid, Box, Tab } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { EmpresasContext } from '../../../../contexts/EmpresasContext'
import { CheckoutContext } from '../../../../contexts/CheckoutContext'
import { UsuarioContext } from '../../../../contexts/UsuarioContext'
import { LocalStorage, Services } from '../../../../services'
import RouterHook from '../../../../contexts/RouterHook'
import { AuthContext } from '../../../../contexts/AuthContext'
import ResumoAgendConf from './ResumoAgendConf'
import Checkout from '../../Checkout'
import Contact from './Contact'
import DiariasList from './DiariasList'
import QuadrasList from './QuadrasList'
import NoAccess from './NoAccess'
import ListTorneios from './ListTorneios'

export default function CentroEsportivo() {
  const serverRouter = RouterHook()
  const { sttAuthCtx } = React.useContext(AuthContext)
  const { userUCtx } = React.useContext(UsuarioContext)
  const { sttPg, actionsCtxEmps } = React.useContext(EmpresasContext)
  const { modaisChkt, actionsChkt } = React.useContext(CheckoutContext)

  const exibeTorneios = false

  function ReturnSttPage() {
    function ReturnMenu() {
      const action = LocalStorage.get('back-action')
      if (action) {
        LocalStorage.remove('back-action')
        let query = ':localizacao'
        if (userUCtx.usuario.cidade && userUCtx.usuario.estado) {
          query = `${
            userUCtx.usuario.estado.length === 2
              ? userUCtx.usuario.estado
              : Services.ReturnSiglaEstado(userUCtx.usuario.estado)
          }-${Services.RemoveCaracteresEspeciais(userUCtx.usuario.cidade)}`
        }
        serverRouter('home', query)
        return true
      }
      return false
    }
    if (sttPg.modePg === 'quadras') {
      if (ReturnMenu()) return
      return serverRouter('back')
    } else if (sttPg.modePg === 'diarias') {
      if (ReturnMenu()) return
      serverRouter('back')
      return actionsCtxEmps.handleModeSttPg({ modePg: 'quadras', selectedHorarios: [] })
    } else if (sttPg.modePg === 'checkout') {
      if (modaisChkt.cartaoCredito) return actionsChkt.handleModaisChkt('cartaoCredito', false)
      else if (modaisChkt.cpf) return actionsChkt.handleModaisChkt('cpf', false)
      else if (modaisChkt.cupom) return actionsChkt.handleModaisChkt('cupom', false)
      else if (modaisChkt.horaFx) return actionsChkt.handleModaisChkt('horaFx', false)
      else return actionsCtxEmps.handleModeSttPg({ modePg: 'quadras', selectedHorarios: [] })
    } else if (sttPg.modePg === 'errorComunic' || sttPg.modePg === 'errorLink') {
      return actionsCtxEmps.handleModeSttPg({ modePg: 'quadras', selectedHorarios: [] })
    } else {
      if (ReturnMenu()) return
      return serverRouter('back')
    }
  }

  function handleTorneio(torneio) {
    serverRouter('torneio', torneio.idtorneio)
  }

  const handleTabChange = (event, newValue) => {
    if (newValue === 'quadras') actionsCtxEmps.handleSttPg('modePg', 'quadras')
    else if (newValue === 'diarias') actionsCtxEmps.handleSttPg('modePg', 'diarias')
    else if (newValue === 'competicoes') actionsCtxEmps.handleSttPg('modePg', 'competicoes')
  }

  //console.log('sttPg', sttPg)
  React.useEffect(() => {
    document.title = sttPg.empresa?.nome
      ? `${sttPg.empresa.nome} | Agendei Quadras`
      : 'Agendei Quadras'
    window.history.pushState(null, null, window.location.pathname)
    window.addEventListener('popstate', ReturnSttPage)
    return () => {
      window.removeEventListener('popstate', ReturnSttPage)
    }
  }, [sttPg.modePg, modaisChkt])
  return (
    <>
      {sttPg.modePg === 'noAccess' || sttPg.modePg === 'config' ? (
        <NoAccess />
      ) : sttPg.modePg === 'quadras' ||
        sttPg.modePg === 'diarias' ||
        sttPg.modePg === 'competicoes' ? (
        <Grid container rowGap={3} sx={{ padding: '0px 14px', maxWidth: '1200px' }}>
          <Grid item xs={12}>
            <Contact />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ marginBottom: `${sttPg.selectedHorarios.length > 0 ? '100px' : 0}` }}
          >
            <Card sx={{ borderRadius: '10px', marginBottom: '10px' }}>
              {sttAuthCtx.isLogged &&
              (sttPg.empresa.licenca?.moduloDiaria === 1 || sttPg.empresa.lenght) ? (
                <TabContext value={sttPg.modePg}>
                  <Box sx={sxTabPanel.tabBox}>
                    <TabList onChange={handleTabChange} sx={{ display: 'flex' }}>
                      <Tab label='Agendar horário' value='quadras' />
                      {sttPg.empresa.licenca?.moduloDiaria && (
                        <Tab label='Marcar diária' value='diarias' />
                      )}
                      {exibeTorneios && sttPg.empresa.torneios.length > 0 && (
                        <Tab label='Competições' value='competicoes' />
                      )}
                    </TabList>
                  </Box>
                  <TabPanel sx={sxTabPanel.tab} value='quadras'>
                    {/* Agendar horário */}
                    <QuadrasList />
                  </TabPanel>
                  <TabPanel value='diarias'>
                    {/* Marcar diária */}
                    <DiariasList />
                  </TabPanel>
                  {exibeTorneios && (
                    <TabPanel value='competicoes'>
                      {/* Competições */}
                      <Box sx={sxTabPanel.containTorneios}>
                        <ListTorneios
                          torneios={sttPg.empresa.torneios}
                          onTornamentClick={tr => handleTorneio(tr)}
                        />
                      </Box>
                    </TabPanel>
                  )}
                </TabContext>
              ) : (
                <QuadrasList />
              )}
            </Card>
          </Grid>
          {sttPg.selectedHorarios.length > 0 && <ResumoAgendConf />}
        </Grid>
      ) : sttPg.modePg === 'checkout' ? (
        <Checkout />
      ) : sttPg.modePg === 'errorComunic' ? (
        <CompError mode={'errorComunic'} />
      ) : (
        sttPg.modePg === 'errorLink' && (
          <CompError
            mode={'errorLink'}
            title={'Aviso'}
            message={
              'Parece que não encontramos a página que você está procurando. Por favor, verifique o link e tente novamente.'
            }
          />
        )
      )}
    </>
  )
}

const sxTabPanel = {
  tab: {
    pt: 0,
  },
  tabBox: {
    display: 'flex',
    borderBottom: 1,
    borderColor: 'divider',
    justifyContent: 'center',
  },
  containTorneios: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    height: 'auto',
    width: '100%',
    padding: '5px',
  },
}
